import MiniSiteOwnerProfile from './MiniSiteOwnerProfile';
import type { Hotel } from '../../../../core/isValidHotel';
import MiniSiteContents, { MiniSiteContentType } from '../../../../../types/MiniSiteContents';
import MiniSiteContentWithPhoto from './MiniSiteContentWithPhoto';
import MiniSiteSquareFeature from './MiniSiteSquareFeature';
import MiniSiteFullWidthImage from './MiniSiteFullWidthImage';
import MiniSiteCircleFeature from './MiniSiteCircleFeature';
import MiniSiteHalfHalfImages from './MiniSiteHalfHalfImage';
import MiniSiteTextCallOut from './MiniSiteTextCallOut';
import MiniSiteTextBlock from './MiniSiteTextBlock';
import MiniSiteSquareTextBelow from './MiniSiteSquareTextBelow';

type Props = {
  hotel: Hotel;
  miniSiteContents: MiniSiteContents;
};

const MiniSiteHotelDetails = ({ hotel, miniSiteContents }: Props) => {
  const renderMiniSiteContents = () => {
    const miniSiteContentsJSXArray: JSX.Element[] = [];

    miniSiteContents.contents.forEach((miniSiteContent) => {
      if (miniSiteContent.contentType === MiniSiteContentType.OWNER_PROFILE)
        miniSiteContentsJSXArray.push(
          <MiniSiteOwnerProfile
            key={miniSiteContent.id}
            hotel={hotel}
            miniSiteContent={miniSiteContent}
          />
        );

      if (miniSiteContent.contentType === MiniSiteContentType.CONTENT_WITH_PHOTO)
        miniSiteContentsJSXArray.push(
          <MiniSiteContentWithPhoto key={miniSiteContent.id} miniSiteContent={miniSiteContent} />
        );

      if (miniSiteContent.contentType === MiniSiteContentType.SQUARE_FEATURE)
        miniSiteContentsJSXArray.push(
          <MiniSiteSquareFeature key={miniSiteContent.id} miniSiteContent={miniSiteContent} />
        );

      if (miniSiteContent.contentType === MiniSiteContentType.FULL_WIDTH_IMAGE)
        miniSiteContentsJSXArray.push(
          <MiniSiteFullWidthImage key={miniSiteContent.id} miniSiteContent={miniSiteContent} />
        );

      if (miniSiteContent.contentType === MiniSiteContentType.CIRCLE_FEATURE)
        miniSiteContentsJSXArray.push(
          <MiniSiteCircleFeature key={miniSiteContent.id} miniSiteContent={miniSiteContent} />
        );

      if (miniSiteContent.contentType === MiniSiteContentType.HALF_HALF_IMAGES)
        miniSiteContentsJSXArray.push(
          <MiniSiteHalfHalfImages key={miniSiteContent.id} miniSiteContent={miniSiteContent} />
        );

      if (miniSiteContent.contentType === MiniSiteContentType.TEXT_CALL_OUT)
        miniSiteContentsJSXArray.push(
          <MiniSiteTextCallOut key={miniSiteContent.id} miniSiteContent={miniSiteContent} />
        );

      if (miniSiteContent.contentType === MiniSiteContentType.TEXT_BLOCK)
        miniSiteContentsJSXArray.push(
          <MiniSiteTextBlock key={miniSiteContent.id} miniSiteContent={miniSiteContent} />
        );

      if (miniSiteContent.contentType === MiniSiteContentType.SQUARE_TEXT_BELOW)
        miniSiteContentsJSXArray.push(
          <MiniSiteSquareTextBelow key={miniSiteContent.id} miniSiteContent={miniSiteContent} />
        );
    });

    return miniSiteContentsJSXArray;
  };

  return <div className="flex flex-col gap-12 bg-gray-50 py-10">{renderMiniSiteContents()}</div>;
};

export default MiniSiteHotelDetails;
